import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = {
	auth: true
}

export default {
	path: '/archives',
	name: 'archives',
	meta,
	redirect: {
		name: 'archives-index'
	},
	component: layoutHeaderAside,
	children: (pre => [
		{
			path: 'archivesList',
			name: `${pre}archivesList`,
			component: _import('member/archivesListReadonly'),
			meta: {
				...meta,
				title: '查看档案'
			}
		},
	])('archives-')
}